import { gql } from 'graphql-request'

export const TOGGLE_FOLLOW_USER = gql`
  mutation ToggleFollowUser($toggleFollowUserInput: ToggleFollowUserInput!) {
    toggleFollowUser(toggleFollowUserInput: $toggleFollowUserInput) {
      type
    }
  }
`
